// Keep the identity function around for default iteratees.
export default function identity(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.8@underscore/modules/identity.js
// module id = 202
// module chunks = 115